import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const AverageIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      fill={theme.palette.text.primary}
      height={props.width} width={props.width} viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='12' cy='12' r='8' stroke='black' stroke-width='2' />
      <line x1='19' y1='5' x2='5' y2='19' stroke='black' stroke-width='2' />
    </svg>
  )
}
export default AverageIcon
